import * as Yup from 'yup';

import { requiredString, emailString, getPhoneNumberString } from 'src/utils/schemas';
import { quoteStage, quoteStatus } from '../../Quotes/constants';

export const quoteUserValidationSchema = Yup.object({
	givenNames: requiredString,
	lastNames: requiredString,
	professionId: requiredString,
	email: emailString,
	phone: getPhoneNumberString(false),
});

export const validationSchema = Yup.object({
	status: requiredString.oneOf(Object.values(quoteStatus), 'Status must be valid quote status'),
	stage: requiredString.oneOf(Object.values(quoteStage), 'Stage must be valid quote stage'),
	clients: Yup.array(quoteUserValidationSchema),
	intermediaries: Yup.array(quoteUserValidationSchema),
	referrers: Yup.array(quoteUserValidationSchema),
});
